interface IIconCalendarProps {
  className?: string;
}

export const IconCalendar = ({ className }: IIconCalendarProps) => (
  <svg className={className} width="23" height="24" viewBox="0 0 23 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 7V23C0 23.55 0.45 24 1 24H22C22.55 24 23 23.55 23 23V7H0ZM5 22H2V19H5V22ZM5 18H2V15H5V18ZM5 14H2V11H5V14ZM9 22H6V19H9V22ZM9 18H6V15H9V18ZM9 14H6V11H9V14ZM13 22H10V19H13V22ZM13 18H10V15H13V18ZM13 14H10V11H13V14ZM17 22H14V19H17V22ZM17 18H14V15H17V18ZM17 14H14V11H17V14ZM21 22H18V19H21V22ZM21 18H18V15H21V18ZM21 14H18V11H21V14ZM23 3V6H0V3C0 2.45 0.45 2 1 2H3V1C3 0.45 3.45 0 4 0H5C5.55 0 6 0.45 6 1V2H17V1C17 0.45 17.45 0 18 0H19C19.55 0 20 0.45 20 1V2H22C22.55 2 23 2.45 23 3Z" />
  </svg>
);
